import PCLNAnalytics from '@pcln/analytics'
import get from 'lodash/get'
import { isServerSide } from './isServerSide'

let BASE_LOG_OBJECT = {}

/* = Search Response logging */
function _createSearchResponseLogEvent(searchType, error, result) {
  if (typeof error === 'object' && !!error) {
    return Object.assign(
      {},
      BASE_LOG_OBJECT,
      { searchType, action: 'Search Error' },
      {
        errorCode: error.code,
        errorDescription: error.message,
        errorStack: error.stack,
        requestId: get(error, 'requestInfo.requestId', ''),
        cguid: get(error, 'requestInfo.clientGUID', ''),
        vid: get(error, 'requestInfo.visitId', ''),
        userAgent: get(error, 'requestInfo.userAgent', ''),
      }
    )
  }

  if (result) {
    let errorObj = {}
    const { error: successError, listingsMetaData } = result

    const {
      processorID: serverID,
      resultCode,
      itineraryType,
      responseTimeStamp, // add  to fly-ql
      searchSessionKey,
      requestId,
      elapsedTime, // add  to fly-ql
      clientSessionId,
    } = listingsMetaData

    // "successError" only shows up when the response is 200 but there is an error object in it like "Zero Itins Returned"
    if (successError) {
      errorObj = {
        action: 'Search result with error',
        errorCode: successError.code || 'none',
        errorDescription: successError.desc || 'none',
      }
    }

    return Object.assign(
      {},
      BASE_LOG_OBJECT,
      {
        searchType,
        serverID,
        resultCode,
        itineraryType,
        responseTimeStamp,
        searchSessionKey,
        requestId,
        elapsedTime,
        clientSessionId,
      },
      errorObj
    )
  }

  return {}
}

function logSearchSuccess(type, result) {
  const logEvent = _createSearchResponseLogEvent(type, null, result)
  // only log errors for now.  GA Events log search call and result presently (but no error insights)
  if (logEvent.errorCode || logEvent.errorDescription) {
    PCLNAnalytics.log(logEvent)
  }
}

function logSearchError(type, error) {
  const logEvent = _createSearchResponseLogEvent(type, error, null)
  PCLNAnalytics.logError(logEvent)
  if (!isServerSide) {
    window?.newrelic?.noticeError(logEvent)
  }
}

function logSearchInitiated(type, requestInfo) {
  const logEvent = {
    type,
    action: 'Search Initiated',
    requestId: get(requestInfo, 'requestId', ''),
    cguid: get(requestInfo, 'clientGUID', ''),
    vid: get(requestInfo, 'visitId', ''),
  }
  PCLNAnalytics.log(logEvent)
}

const clientLogger = (PclnBootstrapData) => {
  if (!PclnBootstrapData) return

  const {
    requestLocals: {
      webstats: { clientGUID, visitId, userAgent },
    },
  } = PclnBootstrapData

  BASE_LOG_OBJECT = {
    action: 'Search Response Recieved in Client',
    cguid: clientGUID,
    vid: visitId,
    userAgent,
  }
}

export { clientLogger, logSearchInitiated, logSearchError, logSearchSuccess, _createSearchResponseLogEvent }
